export function readFileAsText(
  file: File,
): Promise<string | ArrayBuffer | null> {
  return new Promise(function (resolve, reject) {
    const fr = new FileReader()

    fr.onload = function () {
      resolve(fr.result)
    }

    fr.onerror = function () {
      reject(fr)
    }

    fr.readAsText(file)
  })
}

export function getExtension(filename: string) {
  const parts = filename.split('.')

  return parts[parts.length - 1]
}

export function isImage(filename: string) {
  const ext = getExtension(filename)

  switch (ext.toLowerCase()) {
    case 'jpg':
    case 'gif':
    case 'bmp':
    case 'jpeg':
    case 'png':
      return true
  }

  return false
}

export function isVideo(filename: string) {
  const ext = getExtension(filename)

  switch (ext.toLowerCase()) {
    case 'm4v':
    case 'avi':
    case 'mpg':
    case 'mp4':
    case 'movie':
      return true
  }

  return false
}
